// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";
import KazakhstanRoundSvg from "static/icons/kazakhstan-round.svg";
import KyrgyzstanSvg from "static/icons/kyrgyzstan.svg";
import UzbekistanSvg from "static/icons/uzbekistan.svg";

function CountryIcon(Props) {
  let country = Props.country;
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */0 :
    case /* COUNTRY_KAZ */1 :
        break;
    case /* COUNTRY_KGZ */2 :
        return JsxRuntime.jsx(KyrgyzstanSvg, {
                    className: "rounded-xl"
                  });
    case /* COUNTRY_UZB */3 :
        return JsxRuntime.jsx(UzbekistanSvg, {
                    className: "rounded-xl"
                  });
    
  }
  return JsxRuntime.jsx(KazakhstanRoundSvg, {});
}

const make = CountryIcon;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
